import { render, staticRenderFns } from "./PermissionDenyComponent.vue?vue&type=template&id=6396506c&scoped=true&"
import script from "./PermissionDenyComponent.vue?vue&type=script&lang=js&"
export * from "./PermissionDenyComponent.vue?vue&type=script&lang=js&"
import style0 from "./PermissionDenyComponent.vue?vue&type=style&index=0&id=6396506c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6396506c",
  null
  
)

export default component.exports